// SMS 발송 유틸리티 함수

const NOTIFICATION_SERVER = process.env.REACT_APP_NOTIFICATION_SERVER || "http://localhost:3001";

/**
 * 전화번호 정규화 (하이픈 제거)
 * @param {string} phoneNumber - 전화번호
 * @returns {string} 하이픈이 제거된 전화번호
 */
function normalizePhoneNumber(phoneNumber) {
  if (!phoneNumber) return '';
  // 하이픈, 공백, 괄호 등 모든 특수문자 제거
  return phoneNumber.replace(/[-\s()]/g, '');
}

/**
 * SMS 발송 함수
 * @param {string} phoneNumber - 수신자 전화번호 (하이픈 있어도 자동 제거)
 * @param {string} content - 메시지 내용
 * @param {string} name - 수신자 이름 (선택)
 * @param {string} subject - 제목 (LMS용, 선택)
 * @param {string} messageType - 메시지 타입 (AUTO, SMS, LMS)
 * @returns {Promise<{success: boolean, data?: any, error?: string}>}
 */
export async function sendSMS({
  phoneNumber,
  content,
  name = '수신자',
  subject = '알림',
  messageType = 'AUTO'
}) {
  try {
    // 전화번호 정규화 (하이픈 자동 제거)
    const normalizedPhone = normalizePhoneNumber(phoneNumber);
    
    const response = await fetch(`${NOTIFICATION_SERVER}/api/test/send-sms`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        phoneNumber: normalizedPhone,
        content,
        name,
        subject,
        messageType
      }),
    });

    const data = await response.json();

    if (data.success) {
      return { success: true, data };
    } else {
      return { success: false, error: data.error || '문자 발송 실패' };
    }
  } catch (error) {
    console.error('SMS 발송 오류:', error);
    return { success: false, error: error.message };
  }
}

/**
 * 회원가입 안내 SMS 발송
 * @param {string} phoneNumber - 수신자 전화번호
 * @param {string} name - 수신자 이름
 * @returns {Promise<{success: boolean, data?: any, error?: string}>}
 */
export async function sendSignUpInvitationSMS(phoneNumber, name) {
  const content = `[부산대학교 소비자생활협동조합] ${name}님, 안녕하세요!\n\n관리자가 구인 풀에 회원님을 등록했습니다.\n\n회원가입을 진행하시면 구인 공고를 확인하고 지원하실 수 있습니다.\n\n지금 바로 가입해주세요!\n\nhttps://hr.pnucoop.co.kr/`;
  
  return sendSMS({
    phoneNumber,
    content,
    name,
    subject: '회원가입 안내',
    messageType: 'AUTO'
  });
}

/**
 * 여러 명에게 SMS 발송 (배치)
 * @param {Array<{phoneNumber: string, name: string, content: string}>} recipients - 수신자 목록
 * @returns {Promise<{successCount: number, failCount: number, results: Array}>}
 */
export async function sendBatchSMS(recipients) {
  let successCount = 0;
  let failCount = 0;
  const results = [];

  for (const recipient of recipients) {
    const result = await sendSMS({
      phoneNumber: recipient.phoneNumber,
      content: recipient.content,
      name: recipient.name,
      subject: recipient.subject || '알림',
      messageType: recipient.messageType || 'AUTO'
    });

    if (result.success) {
      successCount++;
      results.push({
        phoneNumber: recipient.phoneNumber,
        name: recipient.name,
        success: true
      });
    } else {
      failCount++;
      results.push({
        phoneNumber: recipient.phoneNumber,
        name: recipient.name,
        success: false,
        error: result.error
      });
    }
  }

  return { successCount, failCount, results };
}

